import React, { useState } from 'react';
import InputForm from '../../../InputT';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, CircularProgress, TextField, Tooltip, Typography } from '@mui/material';
import { Button, Input, Select } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { Clear, DataArray, MonetizationOn, MonetizationOnOutlined, Money, Phone, SwipeUp } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import SearchInput from '../../../SearchInput';
import CheckBox from '../../../CheckBox';
import SearchModal from '../../../SearchModal';
import RadioBox from '../../../Radiox';
import TextArea from 'antd/es/input/TextArea';
import Datas from "../../../../Data/Data.json"
import { Crypter } from '../../../../Functions/Security/Crypter';
import axios from 'axios';
import DataTypeTable from '../../../../Types/DataTypeTable';
import SweetAlert from "sweetalert2"
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import Data from '../../../../Data/Data.json'
import { DownOutlined } from '@ant-design/icons';
import Spin from 'antd/es/spin';
import Table, { ColumnsType } from 'antd/es/table';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import styled from '@emotion/styled';







//Initialisation des parametres de recherche
//

interface SelectData {
  value: string,
  label: string,
}

function Tab2(props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser()
  const [loading, setLoading] = useState(false)
  const [historiques, setHistoriques] = useState<Array<any>>([])

  const ThemeTable = styled(Table)(() => ({

    ".ant-table-body ": {
      borderBottom: '1px var(--colorOpaque020) solid',
    }

  }
  ));



  // USER TOKEN




  const columns: ColumnsType<any> = [
    {
      title: 'N° Dossié',
      dataIndex: 'NUMDOS',
      width: 110
    },
    {
      title: 'Montant',
      dataIndex: 'MTDEC',
      width: 110
    },
    {
      title: 'Utilisateur',
      dataIndex: 'UTIDEC',
      width: 110
    },
    {
      title: 'Date',
      dataIndex: 'DATDEC',
      width: 110
    },
    {
      title: 'Raison',
      dataIndex: 'RAISON',
    }
  ];
  function loadHistorique() {
    try {
      let hist = JSON.parse(Crypter.decrypt(localStorage.getItem("historique_decaissement") + "")) as Array<any>
      var newHist: Array<any> = []
      hist.map((h: any, indice) => {
        newHist.push(
          {
            "NUMDOS": h.NUMDOS,
            "MTDEC": formatNumber(h.MTDEC) + " XAF",
            "UTIDEC": h.UTIDEC,
            "DATDEC": ReformatDate(h.DATDEC),
            "RAISON": h.RAISON //<Tooltip title={h.RAISON}><label>? (Pointez)</label></Tooltip>
          }
        )
        props.form.setFieldValue('nbDec', indice + 1)
      })

      setHistoriques(newHist)
    } catch (error) {

    }
  }

  setTimeout(() => {
    try {
      let reset = localStorage.getItem(Datas.LocalVariable.reset)
      if (reset == "1") {
        setHistoriques([])
      }
      localStorage.removeItem(Data.LocalVariable.reset)
    }
    catch (error) {
      console.log(error)
    }

    try {
      let isOkay = localStorage.getItem("load_compte")
      if (isOkay == "1") {
        loadHistorique()
      }
      localStorage.removeItem("load_compte")
    } catch (error) { }
  }, .1);



  return (

    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className='border' height={"60%"} width={"85%"} position={"absolute"}>
          <div className='clientP'>
            <div >
              <Box position={"relative"} fontStyle="inherit" width={"99%"} className='border-left tabElement'>
                <Spin spinning={loading}>
                  <Table size='small' style={{ width: "100%" }} columns={columns} dataSource={historiques} scroll={{ y: 285, x: 10 }} pagination={false} />
                </Spin>
                <Box display={"flex"} fontStyle={"inherit"} >
                  <InputForm notRequired width={17} label='Nombre de décaissement' name='nbDec' type='text' error='mobile' />
                  <InputForm notRequired disabled width={11} label='Montant total décaissé' icon={<MonetizationOnOutlined fontSize='small' />} name='mntdecaisse' type='text' error='mobile' />
                </Box>
              </Box>
            </div>
            <div>
            </div>
          </div>
        </Box>
      </div>
    </div>

  )
}
export default Tab2;

// values.NUMCLI, values.PERIODIC, values.MONTEPARG, values.TAUXINT, values.NBPERDIF, values.TYPEPRET, values.TYPAMORT, values.TAUXEPAR, values.NBRECHE, values.MONTAN, values.TYPCALC, values.TAUXTAX, ReformatDate(values.DAT1ECHE), values.MTNCOM1 + values.MTNCOM2 + values.MTNCOM3 + values.MTNCOM4 + values.MTNCOM5